import React from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import { hasGlobalFeature } from 'selectors';
import { routes } from 'constants/config';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import { hasFeatureFlags } from 'utils/features';
import * as contentsSelectors from 'selectors/learn/contents';
import { createCompoundId } from 'selectors/learn/helpers';
import { TabList, Tab } from 'components/shared/TabbedView';
import NoActivity from 'components/Learn/svg/NoActivity.jsx';
import { sortByDate } from 'components/Learn/Content/Assignments/sortHelpers';
import ContentCard from '../../shared/LearnContentCard';
import ViewAllLink from './ViewAllLink';

const IncompleteAssignments = ({
  incompleteAssignments,
  incompleteJourneyAssignments,
  hasAssignments,
  hasLibraryContents,
  hasFeatureChangeAssignmentsToResources,
}) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const hasLearningJourneys = hasFeatureFlags(['readiness-learning-journeys']);
  const isJourneys = selectedIndex === 1;
  incompleteJourneyAssignments = sortByDate(incompleteJourneyAssignments);
  const items = isJourneys
    ? incompleteJourneyAssignments
    : incompleteAssignments;

  const emptyTitle = isJourneys
    ? t('assignments.no_assignments.incomplete.title.journeys')
    : t('assignments.no_assignments.incomplete.title.training_content');
  const emptyDescription = isJourneys
    ? t('assignments.no_assignments.incomplete.description.journeys')
    : t('assignments.no_assignments.incomplete.description.training_content');

  const hasOverdueAssignments =
    incompleteAssignments.findIndex(
      assignment => assignment.progress.isOverdue,
    ) !== -1;
  const hasOverdueJourneyAssignments =
    incompleteJourneyAssignments.findIndex(
      assignment => assignment.progress.isOverdue,
    ) !== -1;

  return (
    <ContentGroup
      className="LearnContentGroup"
      title={
        hasFeatureChangeAssignmentsToResources
          ? t('resources.incomplete.title')
          : t('assignments.incomplete.title')
      }
      items={items}
    >
      {hasLearningJourneys && (
        <ContentGroup.TabbedView
          onSelect={index => setSelectedIndex(index)}
          selectedIndex={selectedIndex}
        >
          <TabList>
            <Tab>
              <div>
                {t('contents.index.toggle.training_content')}
                <div className="TabbedView-count">
                  {incompleteAssignments.length}
                  {hasOverdueAssignments && (
                    <div className="TabbedView-overdue" />
                  )}
                </div>
              </div>
            </Tab>
            <Tab>
              <div>
                {t('contents.index.toggle.learning_journeys')}
                <div className="TabbedView-count">
                  {incompleteJourneyAssignments.length}
                  {hasOverdueJourneyAssignments && (
                    <div className="TabbedView-overdue" />
                  )}
                </div>
              </div>
            </Tab>
          </TabList>
        </ContentGroup.TabbedView>
      )}
      {hasAssignments && hasLibraryContents && (
        <ContentGroup.Action>
          <ViewAllLink
            to={
              hasFeatureChangeAssignmentsToResources
                ? routes.LEARN_RESOURCES
                : routes.LEARN_ASSIGNMENTS
            }
          >
            {hasFeatureChangeAssignmentsToResources
              ? t('resources.view_all')
              : t('assignments.view_all')}
          </ViewAllLink>
        </ContentGroup.Action>
      )}
      {items.length === 0 ? (
        <ContentGroup.EmptyScreen>
          <div className="ContentGroupEmptyScreen-content">
            <NoActivity />
            <div className="ContentGroupEmptyScreen-textMain">{emptyTitle}</div>
            <div className="ContentGroupEmptyScreen-textBody">
              {emptyDescription}
            </div>
          </div>
        </ContentGroup.EmptyScreen>
      ) : (
        <ContentGroup.Items
          render={assignment => (
            <ContentCard key={createCompoundId(assignment)} {...assignment} />
          )}
        />
      )}
    </ContentGroup>
  );
};

const mapStateToProps = state => ({
  incompleteJourneyAssignments:
    assignmentsSelectors.allJourneyAssignmentsByType(state).incomplete,
  incompleteAssignments:
    assignmentsSelectors.allAssignmentsByType(state).incomplete,
  hasAssignments: assignmentsSelectors.hasAssignments(state),
  hasLibraryContents: contentsSelectors.hasLibraryContents(state),
  hasFeatureChangeAssignmentsToResources: hasGlobalFeature(
    state,
    'change_assignments_to_resources',
  ),
});

export default connect(mapStateToProps)(IncompleteAssignments);
